import { filter } from "../components/filter";
import { sliderPrice } from "../components/rangeFilter";
import { defultSortBy } from "../components/sort-by";
import "../scss/collection.scss";
import { toggleDataActive } from "../utils/toggle-dataset";
import { priceVat } from "../components/price-vat";
import { btnShowVariants, btnShowVariantsAjaxinate } from "../components/product.modal";
import { variantOnChange } from "../components/variants-product";
import { Ajaxinate } from 'ajaxinate'
import "../components/mutationObserver";


const initBlog = () => new Ajaxinate({
  container: '#AjaxinateContainer',
  pagination: '#AjaxinatePagination',
  offset: 400,
  loadingText: ``,
  callback: () => {

    /* btnAddToCart('.add-product-cart');
    btnShowVariants('.btn-show-variants-js')
    variantOnChange('.variants')*/
    priceVat();
    var element = document.getElementsByClassName("trustpilot-widget");
    for (var i = 0; i < element.length; i++) {
      window.Trustpilot.loadFromElement(element[i]);
    }
  }
});


initBlog();
defultSortBy();
sliderPrice();
filter();

toggleDataActive(
  '#filter-open',
  '#filter',
  {
    overlay: true,
  },
)

toggleDataActive(
  '.filter-form_name svg',
  '#filter',
  {
    overlay: true,
  },
)
